<div class="section">
  <h4 class="title">My WorkList Managements</h4>
    <div class="row d-flex justify-content-end" *ngIf="Internal_Allocate_show">
        <button class="btn btn-sm btn-dark mb-1 mt-1 mr-4" (click)="internal_allocation()">View Team Allocations</button>
    </div>
  <div class="doc-table">
      <div class="card-box"> <p-table [value]="final_data" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
              <tr class="thhead">
                  <th class="th-1">
                      S.No
                  </th>
                  <th>
                     Bucket ID
                  </th>
                  <th>
                    Bank Name
                  </th>
                  <th>
                    Portfolio Name
                  </th>
                  <th>
                    Allocation Date
                  </th>
                  <!-- <th>
                    Product Name
                  </th>
                  <th>
                    Portfolio Name
                  </th>
                  <th>
                     Total Records
                  </th>
                  <th>
                      Allocated Records
                  </th>
                  <th>
                      Not Allocated Records
                  </th>
                  <th>
                   Uploaded Date
                    </th> -->
                  <th style="width: 110px;text-align:center">
                      Action
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow">
                  <td>{{i+1}}</td>
                  <td>{{item.bucket_id}}</td>
                  <td>
                     <select [(ngModel)]="item.bank_id" class="form-control" disabled>
                    <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                    </select>
                   </td>
                  <td>
                    <select [(ngModel)]="item.porfolio_id" class="form-control" disabled>
                        <option *ngFor="let item of original_portfolio_list" [value]="item._id">{{item.portfolio_type}}</option>
                    </select>
                  </td>
                  <!-- <td>{{item.bank_name.bank_name}}</td>

                  <td>{{item.product_id.product_type}}</td>
                  <td>{{item.portfolio_id.portfolio_type}}</td>
                  <td>{{item.record_count}}</td>
                  <td>{{item.allocated_record}}</td>
                  <td>{{item.not_allocated_record}}</td>
                  <td>{{item.createdAt | date}}</td> -->
                  <td>{{item.date_of_allocations | date}}</td>
                  <td class="act">
                      <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="move_to_select(item)"
                          pTooltip="View Record"></i>
                  </td>
              </tr>
          </ng-template>
       </p-table>  </div>
  </div>
</div>
